<template>
  <div>
    <el-dialog
      top="6vh"
      width="330px"
      center
      :title="`${faceVideoStatusObj.bankName} 扫脸视频状态`"
      :visible="faceVideoStatusObj.visible"
      @close="HandleCancel()"
    >
      <el-radio-group v-model="faceVideoStatus">
        <el-radio
          style="padding: 10px"
          v-for="option in faceVideoStatusOptions"
          :key="option.label"
          :label="Number(option.value)"
          :disabled="option.disabled"
          >{{ option.label }}</el-radio
        >
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="HandleSubmit()"
          :loading="submitLoading"
          type="warning"
          size="small"
          >更新状态</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { updateFaceVideoStatus } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: {
    faceVideoStatusObj: {
      type: Object,
    },
  },
  data() {
    return {
      submitLoading: false,
      faceVideoStatus: null,
      faceVideoStatusOptions: [],
    };
  },
  watch: {
    faceVideoStatusObj(row) {
      if (row.visible) {
        this.faceVideoStatus = this.faceVideoStatusObj.faceVideoStatus;
        this.getOptions();
      }
    },
  },
  methods: {
    getOptions() {
      let faceVideoStatusOptionArr = [];
      for (const [key, value] of Object.entries(
        varCommon.faceVideoStatusOptions
      )) {
        let disabled = false;

        // 代理、管理员、操作员、操作员管理员可操作「初审通过」
        if (
          ["agent", "admin", "operator", "operator_admin"].indexOf(
            this.userInfo.userType
          ) === -1 &&
          key === "2"
        ) {
          disabled = true;
        }

        // 只有管理员、操作员和操作员管理员可操作「实际可用」、「不可用」状态
        if (
          ["admin", "operator", "operator_admin"].indexOf(
            this.userInfo.userType
          ) === -1 &&
          (key === "3" || key === "4")
        ) {
          disabled = true;
        }

        // 「尚未上传」和「新上传」选项移除，系统会自动变换其状态
        if (key !== "0" && key !== "1") {
          faceVideoStatusOptionArr.push({
            label: value,
            value: key,
            disabled,
          });
        }
      }
      this.faceVideoStatusOptions = faceVideoStatusOptionArr;
    },
    HandleSubmit() {
      this.submitLoading = true;
      updateFaceVideoStatus({
        accId: this.faceVideoStatusObj.id,
        faceVideoStatus: this.faceVideoStatus,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.$emit("HandleGetList");

          if (this.faceVideoStatus === 4 && res.code === 200) {
            this.$confirm(
              "系统注意到你已标记此卡扫脸视频不可用，是否要同步下线此银行卡，通知卡主重新上传？",
              "联动提醒",
              {
                confirmButtonText: varCommon.message.confirm,
                cancelButtonText: varCommon.message.cancel,
                type: "warning",
              }
            )
              .then(() => {
                this.$emit("update:report-obj", {
                  id: this.faceVideoStatusObj.id,
                  bankName: this.faceVideoStatusObj.bankName,
                  bankCardNumber: this.faceVideoStatusObj.bankCardNumber,
                  eventType: 0,
                  remark: "扫脸视频无法通过（正面）",
                  visible: true,
                });
              })
              .catch(() => {})
              .finally(() => {
                this.HandleCancel();
              });
          } else {
            this.HandleCancel();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    HandleCancel() {
      this.$emit("update:face-video-status-obj", {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/FaceVideoStatusDialog.vue